<template>
	<div>
		<gallery
			:images="parsedGallery"
			:index="index"
			@close="index = null"
			:id="'gallery-' + uniqueId"
		></gallery>
		<div class="container">
			<div class='gallery'>
				<div
					class="image"
					v-for="(image, imageIndex) in parsedGalleryMeta"
					:key="imageIndex"
					@click="index = imageIndex"
				>
					<div class='overlay'>
						<span
							class="title"
							v-html="image.title"
							v-if="image.title"
						></span>
						<span
							class="caption"
							v-html="image.caption"
							v-if="image.caption"
						></span>
					</div>
					<img
						:src="image.url"
						:alt="image.title"
						v-if="image.url"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueGallery from 'vue-gallery';

export default {
	data() {
		return {
			index: null,
		};
	},

	props: {
		gallery: {},
		meta: {},
		uniqueId: {
			default: 'temp',
		},
	},

	computed: {
		parsedGallery() {
			if (this.gallery) {
				return JSON.parse(this.gallery);
			} else {
				return null;
			}
		},

		parsedGalleryMeta() {
			if (this.meta) {
				return JSON.parse(this.meta);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: { gallery: VueGallery },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.gallery {
	grid-column: 1 / span 12;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 40px;

	@media (max-width: $mobile-xl) {
		grid-template-columns: 1fr 1fr;
		gap: 20px;
	}

	.image {
		aspect-ratio: 1 / 1;
		position: relative;
		display: flex;

		&:hover {
			cursor: pointer;

			.overlay {
				opacity: 1;
				transition: 0.2s ease all;
			}
		}

		.overlay {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background: rgba(#040930, 0.7);
			display: flex;
			justify-content: center;
			align-items: center;
			color: var(--white);
			text-transform: capitalize;
			pointer-events: none;
			opacity: 0;
			transition: 0.2s ease all;
			flex-direction: column;
			padding: 20px;

			.title {
				font-size: 20px;
				font-weight: bold;
				max-width: calc(100% - 40px);
				text-align: center;
			}

			.caption {
				font-size: 14px;
				font-weight: normal;
				margin-top: 20px;
				max-width: calc(100% - 40px);
				text-align: center;
			}
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/LightboxGallery.vue